import { createSlice } from "@reduxjs/toolkit";
import { SignUp } from "services/user/user.service";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    loginData: [],
    loginDataLoading: false,
    loginDataError: null,
  },
  extraReducers: 
  (builder) => {
    builder.addCase(SignUp.fulfilled, (state, action) => {
        state.loginData = action.payload
        state.loginDataLoading = false
    });

    builder.addCase(SignUp.rejected, (state, action) => {
        state.loginDataLoading = true
        state.loginData = []
        state.loginDataError = action.error?.message
    });
  },
});

export default loginSlice.reducer;
